import React, { useEffect } from "react";
import ClockForm from "./ClockForm";
import { colors, fonts, space, radius } from "../theme";

// The clock-in form as a window over the Waiter / Kitchen screen, so a half-built order is never lost.
export default function ClockWindow({ info, onClose, onDone }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center", padding: space[3] }} onClick={onClose}>
      <div role="dialog" aria-label="Clock in or out" onClick={(e) => e.stopPropagation()} style={{ background: colors.surface, borderRadius: radius.lg, width: "100%", maxWidth: 420, maxHeight: "94vh", overflowY: "auto", padding: space[3] }} data-testid="clock-window">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: `0 ${space[2]}` }}>
          <strong style={{ fontFamily: fonts.display, fontSize: 18, color: colors.textPrimary }}>Clock in / out</strong>
          <button onClick={onClose} aria-label="Close" style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: colors.textSecondary }}>✕</button>
        </div>
        <ClockForm
          tenant={info.tenant}
          initialName={info.name || ""}
          onSuccess={() => setTimeout(onDone, 2500)}
          knownStatus={info.linked ? { clocked_in: info.clocked_in, since: info.since, has_earlier_shift_today: !!info.has_earlier_shift_today } : null}
        />
      </div>
    </div>
  );
}
